import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceOverviewRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-overview',
	path: '/jira/settings/system/performance/overview',
};
